import React from "react";
import Button from "components/button";
import UseContext from "hooks/useContext";
import SectionWrapper from "pages/createMission/components/SectionWrapper";
import {
    buildSummaryFromWizardData,
    formatList,
} from "pages/missionTemplates/components/MissionTemplateSummary";

const ConfirmationTemplate = () => {
    const { templateData, setTemplatePage } = UseContext();
    const summary = buildSummaryFromWizardData(templateData);
    const toolsLine =
        templateData?.tools?.length > 0
            ? formatList(templateData.tools)
            : "Aucun";
    const licencesLine =
        templateData?.licences?.length > 0
            ? formatList(templateData.licences)
            : "Aucun";
    const languagesLine =
        templateData?.languages?.length > 0
            ? formatList(templateData.languages)
            : "Aucune";

    return (
        <div className={"flex flex-col gap-6"}>
            <SectionWrapper
                title="Confirmation"
                description="Vérifiez les informations de la fiche de poste avant de l'enregistrer."
            >
                <div className={"flex flex-col gap-6"}>
                    <div
                        className={
                            "flex flex-col gap-4 border border-gray-100 rounded-md p-4"
                        }
                    >
                        <div className={"flex justify-between items-center"}>
                            <span className="ft-xl font-medium text-gray-900">
                                Description
                            </span>
                            <Button
                                color={"DEFAULT"}
                                onClick={() => setTemplatePage(1)}
                                size={"SM"}
                            >
                                Modifier
                            </Button>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Intitulé de la fiche :{" "}
                            <span className={"text-gray-900"}>
                                {summary.name || "—"}
                            </span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Secteur d&apos;activité :{" "}
                            <span className={"text-gray-900"}>
                                {summary.activity || "—"}
                            </span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Qualification :{" "}
                            <span className={"text-gray-900"}>
                                {summary.qualification || "—"}
                            </span>
                        </div>
                    </div>

                    <div
                        className={
                            "flex flex-col gap-4 border border-gray-100 rounded-md p-4"
                        }
                    >
                        <div className={"flex justify-between items-center"}>
                            <span className="ft-xl font-medium text-gray-900">
                                Pré-requis
                            </span>
                            <Button
                                color={"DEFAULT"}
                                onClick={() => setTemplatePage(2)}
                                size={"SM"}
                            >
                                Modifier
                            </Button>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Matériel :{" "}
                            <span className={"text-gray-900"}>{toolsLine}</span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Permis :{" "}
                            <span className={"text-gray-900"}>
                                {licencesLine}
                            </span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Langues :{" "}
                            <span className={"text-gray-900"}>
                                {languagesLine}
                            </span>
                        </div>
                    </div>

                    <div
                        className={
                            "flex flex-col gap-4 border border-gray-100 rounded-md p-4"
                        }
                    >
                        <div className={"flex justify-between items-center"}>
                            <span className="ft-xl font-medium text-gray-900">
                                Lieu et rémunération
                            </span>
                            <Button
                                color={"DEFAULT"}
                                onClick={() => setTemplatePage(3)}
                                size={"SM"}
                            >
                                Modifier
                            </Button>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Adresse :{" "}
                            <span className={"text-gray-900"}>
                                {summary.address || "—"}
                            </span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Taux horaire brut :{" "}
                            <span className={"text-gray-900"}>
                                {summary.salary || "—"}
                            </span>
                        </div>
                    </div>

                    <div
                        className={
                            "flex flex-col gap-4 border border-gray-100 rounded-md p-4"
                        }
                    >
                        <div className={"flex justify-between items-center"}>
                            <span className="ft-xl font-medium text-gray-900">
                                Responsable
                            </span>
                            <Button
                                color={"DEFAULT"}
                                onClick={() => setTemplatePage(4)}
                                size={"SM"}
                            >
                                Modifier
                            </Button>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Nom :{" "}
                            <span className={"text-gray-900"}>
                                {templateData?.contact_name || "—"}
                            </span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Fonction :{" "}
                            <span className={"text-gray-900"}>
                                {templateData?.contact_poste || "—"}
                            </span>
                        </div>
                    </div>

                    <div
                        className={
                            "flex flex-col gap-4 border border-gray-100 rounded-md p-4"
                        }
                    >
                        <div className={"flex justify-between items-center"}>
                            <span className="ft-xl font-medium text-gray-900">
                                Informations supplémentaires
                            </span>
                            <Button
                                color={"DEFAULT"}
                                onClick={() => setTemplatePage(4)}
                                size={"SM"}
                            >
                                Modifier
                            </Button>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Pour le candidat :{" "}
                            <span className={"text-gray-900"}>
                                {templateData?.other || "Aucune information"}
                            </span>
                        </div>
                        <div className={"ft-sm text-gray-500"}>
                            Pour l&apos;agence :{" "}
                            <span className={"text-gray-900"}>
                                {templateData?.other_interim ||
                                    "Aucune information"}
                            </span>
                        </div>
                    </div>
                </div>
            </SectionWrapper>
        </div>
    );
};

export default ConfirmationTemplate;
